import {
  createBankroll,
  deleteBankroll,
  fetchBankrolls,
  fetchPlayers,
  updateBankroll,
} from 'config/api'
import { BANKROLL_KEY } from 'config/constants'
import React from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { connect } from 'react-redux'

export const BankrollContext = React.createContext({})

function BankrollProvider({ authenticated, children }) {
  const [current, setCurrent] = React.useState()
  const [switching, setSwitching] = React.useState(false)

  const qClient = useQueryClient()

  const selectBankroll = React.useCallback(
    bankroll => {
      localStorage.setItem(BANKROLL_KEY, bankroll.id)
      qClient.removeQueries()
      setCurrent(bankroll)
      setSwitching(true)
      setTimeout(() => {
        setSwitching(false)
      }, 1000)
    },
    [setCurrent, qClient],
  )

  const qBankrolls = useQuery('bankrolls', fetchBankrolls, {
    enabled: authenticated,
    onSuccess: data => {
      let bankroll

      // Set the last bankroll viewed
      const lastBankrollId = localStorage.getItem(BANKROLL_KEY)
      if (lastBankrollId) {
        bankroll = data.results.find(p => p.id === lastBankrollId)
      }

      // Default to the first bankroll
      if (!bankroll) {
        bankroll = data.results[0]
      }

      setCurrent(bankroll)
    },
  })

  const qPlayers = useQuery(
    ['bankrolls', 'players'],
    () => {
      return fetchPlayers(current.id)
    },
    {
      enabled: !!current?.id,
    },
  )

  const mCreateBankroll = useMutation(createBankroll, {
    onSuccess: () => {
      qClient.invalidateQueries('bankrolls')
    },
  })

  const mUpdateBankroll = useMutation(updateBankroll, {
    onSuccess: () => {
      qClient.invalidateQueries('bankrolls')
    },
  })

  const mDeleteBankroll = useMutation(deleteBankroll, {
    onSuccess: () => {
      qClient.invalidateQueries('bankrolls')
    },
  })

  return (
    <BankrollContext.Provider
      value={{
        currentBankroll: current,
        switchingBankrolls: switching,
        bankrolls: qBankrolls.isSuccess ? qBankrolls.data.results : [],
        players: qPlayers.isSuccess ? qPlayers.data : [],
        selectBankroll,
        createBankroll: mCreateBankroll.mutateAsync,
        updateBankroll: mUpdateBankroll.mutateAsync,
        deleteBankroll: mDeleteBankroll.mutateAsync,
      }}
    >
      {children}
    </BankrollContext.Provider>
  )
}

const mapState = state => ({
  authenticated: state.auth.authenticated,
})

export default connect(mapState)(BankrollProvider)
